export const validateName = (name: any) => {
  if (!name.trim()) {
    return true;
  } else if (!/[A-Za-z\d]/.test(name)) {
    return true; // Check if Name contains only special characters
  } else {
    return false;
  }
};

export const validatePhoneNumber = (phoneNumber: any) => {
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  return cleanedNumber.length <= 10; // Check if Phone Number has 10 digits
};

export const validateEmail = (email: any) => {
  return /^[a-zA-Z0-9!#$%&*+\/=?^_`{|}~.-]{1,64}@[a-zA-Z0-9.-]{1,255}\.[a-zA-Z]{2,63}$/.test(
    email,
  );
}; // Check if Email format is valid
export const changeNum = (num: any) =>
  num ? num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : num;
